import axios from "axios";
import { getUrl } from "@/common/config";
import { findLanguage } from "@/utility/LocalizationService";
import { DateTime } from "luxon";

export default class ExternalLoginApi {
  constructor() {
    this.url = getUrl();
  }

  async loginToMaestroConnectApi(externalAccessToken, externalRefreshToken) {
    let result = await axios.post(`${this.url}/api/external-auth/login`, {
      accessToken: externalAccessToken
    });

    result = result.data.result;

    localStorage.token = result.accessToken;
    localStorage.refreshToken = result.refreshToken;
    localStorage.externalAccessToken = externalAccessToken;
    localStorage.externalRefreshToken = externalRefreshToken;
    localStorage.language = findLanguage(result.user.Language).id;
    localStorage.organizationCode = result.user.OrganizationCode;
    localStorage.userId = result.user.Id;
    DateTime.now().setLocale(localStorage.language.substring(0, 2));

    axios.defaults.headers.common["Authorization"] = "Bearer " + result.accessToken;
    axios.defaults.headers.common["Accept-Language"] = localStorage.language;

    return {
      accessToken: result.accessToken,
      refreshToken: result.refreshToken,
      user: result.user
    };
  }
}
